import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

import { i18n } from "../../translate/i18n";
import { StatusBadge } from "../../components/ui";

const KNOWN = ["APPROVED", "PENDING", "REJECTED", "PAUSED"];

// Tons do painel: aprovado = ok, pendente = atenção, rejeitado = crítico; o resto é neutro.
const TONE = { APPROVED: "success", PENDING: "warning", REJECTED: "error" };

/**
 * Selo de status do template Meta. REJECTED mostra o motivo no tooltip.
 */
const StatusChip = ({ status, reason }) => {
  const key = String(status || "").toUpperCase();
  const label = KNOWN.includes(key)
    ? i18n.t(`metaTemplates.status.${key}`)
    : key || "-";
  const badge = <StatusBadge color={TONE[key] || "neutral"} label={label} />;
  if (key !== "REJECTED") return badge;
  return (
    <Tooltip
      title={reason || i18n.t("metaTemplates.status.noReason")}
      placement="top"
      arrow
    >
      {/* o Tooltip precisa de um filho que aceite ref */}
      <span style={{ display: "inline-flex", cursor: "help" }}>{badge}</span>
    </Tooltip>
  );
};

export default StatusChip;
